(function ($) {
    let loading = false;

    function loadPosts(taxId, page = 1, isLoadMore = false) {
        if (loading) return;
        loading = true;

        const containerPosts = $('#post-container-news');
        const spinner = $('#loading-news');

        spinner.addClass('is-visible');

        if (isLoadMore) {
            $('.load-nav').remove();
        } else {
            $('.load-nav').remove();
            containerPosts.empty();
        }

        $.ajax({
            url: MyAjax.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_more_news',
                page: page,
                tax: taxId
            },
            success: function (response) {
                loading = false;
                spinner.removeClass('is-visible');

                if (!response || response.trim() === "") {
                    if (!isLoadMore) containerPosts.html('<p>Постів не знайдено.</p>');
                    return;
                }

                if (isLoadMore) {
                    containerPosts.append(response);
                } else {
                    containerPosts.html(response);
                    $('html, body').animate({
                        scrollTop: $(".section-news-list").offset().top - 100
                    }, 500);
                }

                // update URL
                const baseUrl = window.location.href.split('/page/')[0].replace(/\/$/, "");
                const newUrl = page > 1 ? `${baseUrl}/page/${page}/` : `${baseUrl}/`;
                history.pushState({}, "", newUrl);

                linksOverride();
            }
        });
    }

    // 1. Click by category
    $('.section-news-list .tax-name').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $('.tax-name').removeClass('active');
            $(this).addClass('active');
            const taxId = $(this).data('id');
            loadPosts(taxId, 1, false);
        }
    });

    // 2. Click on the page numbers (1, 2, 3...)
    $(document).on('click', '#pagination a.page-numbers', function (e) {
        e.preventDefault();
        const activeTax = $('.tax-name.active').data('id') || '';

        // Extract the page number from the href link
        const href = $(this).attr('href');
        const match = href.match(/\/page\/(\d+)/);
        const targetPage = match ? parseInt(match[1], 10) : 1;

        loadPosts(activeTax, targetPage, false);
    });

    // 3. Click on the Load More button
    $(document).on('click', '#load-more-button a', function (e) {
        e.preventDefault();
        const activeTax = $('.tax-name.active').data('id') || '';

        // We determine the next page
        const match = window.location.href.match(/\/page\/(\d+)/);
        const nextPage = match ? parseInt(match[1], 10) + 1 : 2;

        loadPosts(activeTax, nextPage, true);
    });

    function linksOverride() {
        $("#pagination a.page-numbers").each(function() {
            const currentHref = $(this).attr("href");
            let pageUrl = window.location.href.split('/page/')[0];
            const newHref = currentHref.replace(/https?:\/\/.*wp-admin\/admin-ajax.php/, pageUrl);
            $(this).attr("href", newHref);
        });
    }


    // center tab
    function centerActiveCategory() {
        if (window.innerWidth < 1023) {
            const $activeCategory = $('.section-news-list .tax-name.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-news-list .wrap-scroll');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
                $scrollContainer.animate({scrollLeft: scrollPosition}, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-news-list .tax-name span').on('click', function (e) {
        e.preventDefault();
        const $parentItem = $(this).parent();
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });

})(jQuery);